"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.snowplowFirePrestigeEvent = exports.buildPrestigeEventEntity = exports.snowplowFireUiInteractionEvent = exports.buildUiInteractionEntity = exports.snowplowFireEvent = exports.snowplowFirePageViewEvent = exports.mapEntityToSelfDescribingStructure = exports.initNewTracker = exports.SSR_DISABLED_TRACKING = exports.getTracker = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var browser_tracker_core_1 = require("@snowplow/browser-tracker-core");
var tracker_core_1 = require("@snowplow/tracker-core");
var browser_plugin_performance_navigation_timing_1 = require("@snowplow/browser-plugin-performance-navigation-timing");
var browser_plugin_ga_cookies_1 = require("@snowplow/browser-plugin-ga-cookies");
var track_types_1 = require("@at/track-types");
var tcf_api_1 = require("./tcf-api");
var loadBrowserTrackerLib = function () { return __awaiter(void 0, void 0, void 0, function () {
    var browserTrackerLib;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require(/* webpackChunkName: "BrowserTracker" */ '@snowplow/browser-tracker')); })];
            case 1:
                browserTrackerLib = _a.sent();
                return [2 /*return*/, browserTrackerLib];
        }
    });
}); };
var tracker = {
    enableActivityTracking: function () {
        console.log("Can't enable activity tracking - tracker not yet loaded");
    },
    trackPageView: function () {
        console.log("Can't track page view - tracker not yet loaded");
    },
    trackSelfDescribingEvent: function () {
        console.log("Can't track event - tracker not yet loaded");
    },
    disableAnonymousTracking: function () {
        console.log("Can't disable anonymous tracking - tracker not yet loaded");
    },
    enableAnonymousTracking: function () {
        console.log("Can't enable anonymous tracking - tracker not yet loaded");
    },
    getPageViewId: function () {
        console.log("Can't get previous page view ID - tracker not yet loaded");
    },
    clearUserData: function () {
        console.log("Can't clear user data - tracker not yet loaded");
    },
    core: {
        track: function () {
            console.log("Can't track event - tracker not yet loaded");
        },
    },
};
var getTracker = function () { return tracker; };
exports.getTracker = getTracker;
exports.SSR_DISABLED_TRACKING = false;
var initTrackerPromise;
var trackerLoaded = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (Object.keys((0, browser_tracker_core_1.allTrackers)()).length > 0) {
            //? tracker found
            return [2 /*return*/, Promise.resolve((0, exports.getTracker)())];
        }
        if (initTrackerPromise) {
            //? tracker loading, returning promise
            return [2 /*return*/, initTrackerPromise];
        }
        //? tracker not yet initialised
        return [2 /*return*/, Promise.reject()];
    });
}); };
var initNewTracker = function (_a) {
    var _b = _a.env, env = _b === void 0 ? 'local' : _b, appName = _a.appName, platform = _a.platform, _c = _a.removeAnonymousTracking, removeAnonymousTracking = _c === void 0 ? false : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, activityTracking = _a.activityTracking;
    if (Object.keys((0, browser_tracker_core_1.allTrackers)()).length > 0) {
        return Promise.resolve((0, exports.getTracker)());
    }
    if (ssrMode) {
        exports.SSR_DISABLED_TRACKING = true;
        return Promise.resolve(tracker);
    }
    else {
        exports.SSR_DISABLED_TRACKING = false;
        initTrackerPromise = new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
            var collectorUrl, anonymousTrackingConfiguration, browserTrackerLib, newBrowserTracker;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        collectorUrl = env === 'prod'
                            ? 'avalanche.autotrader.co.uk'
                            : env === 'preprod'
                                ? 'avalanche.preprod.autotrader.co.uk'
                                : 'uk-co-autotrader-gcp.mini.snplow.net';
                        anonymousTrackingConfiguration = {};
                        if (!js_cookie_1.default.get('at_sp_consent') && !removeAnonymousTracking) {
                            anonymousTrackingConfiguration = {
                                anonymousTracking: {
                                    withServerAnonymisation: false,
                                    stateStorageStrategy: 'localStorage',
                                },
                            };
                        }
                        return [4 /*yield*/, loadBrowserTrackerLib()];
                    case 1:
                        browserTrackerLib = _c.sent();
                        newBrowserTracker = browserTrackerLib.newTracker('co', collectorUrl, __assign({ plugins: [
                                (0, browser_plugin_performance_navigation_timing_1.PerformanceNavigationTimingPlugin)(),
                                (0, browser_plugin_ga_cookies_1.GaCookiesPlugin)({
                                    ga4: false,
                                    ua: true,
                                }),
                            ], appId: appName, platform: platform, contexts: {
                                webPage: true,
                                session: true,
                            }, cookieSameSite: 'Lax', cookieSecure: true, eventMethod: 'post', encodeBase64: true, maxLocalStorageQueueSize: 100 }, anonymousTrackingConfiguration));
                        if (newBrowserTracker) {
                            newBrowserTracker.enableActivityTracking({
                                minimumVisitLength: (_a = activityTracking === null || activityTracking === void 0 ? void 0 : activityTracking.minimumVisitLength) !== null && _a !== void 0 ? _a : 10,
                                heartbeatDelay: (_b = activityTracking === null || activityTracking === void 0 ? void 0 : activityTracking.heartbeatDelay) !== null && _b !== void 0 ? _b : 10,
                            });
                            tracker = newBrowserTracker;
                        }
                        resolve(tracker);
                        return [2 /*return*/];
                }
            });
        }); });
        return initTrackerPromise;
    }
};
exports.initNewTracker = initNewTracker;
var mapEntityToSelfDescribingStructure = function (_a) {
    var SCHEMA_KEY = _a.SCHEMA_KEY, rest = __rest(_a, ["SCHEMA_KEY"]);
    return ({
        schema: track_types_1.SCHEMA_STRINGS[SCHEMA_KEY],
        data: rest,
    });
};
exports.mapEntityToSelfDescribingStructure = mapEntityToSelfDescribingStructure;
var snowplowFirePageViewEvent = function (entityArray) { return __awaiter(void 0, void 0, void 0, function () {
    var mappedEntities_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!!exports.SSR_DISABLED_TRACKING) return [3 /*break*/, 4];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, trackerLoaded()
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                ];
            case 2:
                _b.sent();
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                setAnonTrackingFunctions(entityArray);
                mappedEntities_1 = entityArray.map(exports.mapEntityToSelfDescribingStructure);
                tracker.trackPageView({ contextCallback: function () { return mappedEntities_1; } });
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                console.warn('Cannot fire page view event, no trackers detected!');
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.snowplowFirePageViewEvent = snowplowFirePageViewEvent;
var snowplowFireEvent = function (event, entityArray) {
    if (entityArray === void 0) { entityArray = []; }
    return __awaiter(void 0, void 0, void 0, function () {
        var mappedEvent, mappedEntities, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, trackerLoaded()];
                case 1:
                    _b.sent();
                    mappedEvent = (0, exports.mapEntityToSelfDescribingStructure)(event);
                    mappedEntities = entityArray.map(exports.mapEntityToSelfDescribingStructure);
                    tracker.core.track((0, tracker_core_1.buildSelfDescribingEvent)({ event: mappedEvent }), mappedEntities);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    console.warn('Cannot fire event, no trackers detected!');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
exports.snowplowFireEvent = snowplowFireEvent;
var buildUiInteractionEntity = function (label, action) {
    if (action === void 0) { action = 'click'; }
    return ({
        SCHEMA_KEY: 'UiInteraction103',
        label: label,
        action: action,
    });
};
exports.buildUiInteractionEntity = buildUiInteractionEntity;
var snowplowFireUiInteractionEvent = function (label, action, entityArray) {
    if (action === void 0) { action = 'click'; }
    return (0, exports.snowplowFireEvent)((0, exports.buildUiInteractionEntity)(label, action), entityArray);
};
exports.snowplowFireUiInteractionEvent = snowplowFireUiInteractionEvent;
var buildPrestigeEventEntity = function (name) { return ({
    SCHEMA_KEY: 'Prestige104',
    name: name,
}); };
exports.buildPrestigeEventEntity = buildPrestigeEventEntity;
var snowplowFirePrestigeEvent = function (name, entityArray) {
    return (0, exports.snowplowFireEvent)((0, exports.buildPrestigeEventEntity)(name), entityArray);
};
exports.snowplowFirePrestigeEvent = snowplowFirePrestigeEvent;
var setAnonTrackingFunctions = function (entityArray) {
    return (0, tcf_api_1.callWithSnowplowConsentStatus)(function (snowplowConsent) {
        var disableAnonTracking = function () { return __awaiter(void 0, void 0, void 0, function () {
            var browserTracker, previous_page_view_id, anonymousRetrack, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, trackerLoaded()];
                    case 1:
                        browserTracker = _b.sent();
                        browserTracker.disableAnonymousTracking({
                            stateStorageStrategy: 'cookieAndLocalStorage',
                        });
                        if (window) {
                            previous_page_view_id = browserTracker.getPageViewId();
                            anonymousRetrack = {
                                SCHEMA_KEY: 'AnonymousRetrack100',
                                previous_page_view_id: previous_page_view_id,
                            };
                            (0, exports.snowplowFirePageViewEvent)(entityArray.concat(anonymousRetrack));
                            if (window.AT_CONSENT && window.AT_CONSENT.snowplowDisableAnonTracking) {
                                delete window.AT_CONSENT.snowplowDisableAnonTracking;
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        console.warn('Tried to disable anonymous tracking but no trackers detected! Did you maybe forget to initialise your tracker? HMMM?');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var enableAnonTracking = function () { return __awaiter(void 0, void 0, void 0, function () {
            var browserTracker, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, trackerLoaded()];
                    case 1:
                        browserTracker = _b.sent();
                        browserTracker.enableAnonymousTracking({
                            options: { withServerAnonymisation: false },
                            stateStorageStrategy: 'localStorage',
                        });
                        browserTracker.clearUserData({ preserveSession: true, preserveUser: true });
                        if (window.AT_CONSENT && window.AT_CONSENT.snowplowEnableAnonTracking) {
                            delete window.AT_CONSENT.snowplowEnableAnonTracking;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        console.warn('Tried to enable anonymous tracking but no trackers detected! Did you maybe forget to initialise your tracker? HMMM?');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        (0, tcf_api_1.submitConsentEvent)();
        window.AT_CONSENT = __assign(__assign(__assign({}, window.AT_CONSENT), (!snowplowConsent && {
            snowplowDisableAnonTracking: disableAnonTracking,
        })), (snowplowConsent && {
            snowplowEnableAnonTracking: enableAnonTracking,
        }));
    });
};
